import React from 'react'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError.js'
import '../../components/GeneralCss.css'
function InputTable(props) {
    const { label, name, ...rest } = props
    return (
            <div className="row" style={{margin:"2%"}} >

                
                <label >{label}</label>
                <Field id={name} name={name} {...rest} className="form-control"/>
                <ErrorMessage name={name} component={TextError}/>
            </div>
    )
}

export default InputTable